import React from 'react';
import { useTranslate, useCurrentUser } from '@hooks';
import { take } from 'lodash';
import { Table } from '@dotone/react-ui-core';
import { formatAffiliateStats, formatAffiliateType } from './formatters';
import { formatAffiliate } from '../formatters';

const getColumns = ({ t, currentUser }) => [
  {
    dataField: 'id',
    text: t('name'),
    formatter: (cell, row) => formatAffiliate(row, { minimal: true }),
  },
  {
    dataField: 'affiliateType',
    text: t('affiliateType'),
    hidden: currentUser.pro,
    formatter: (cell, row) => formatAffiliateType(cell, { siteInfos: take(row.siteInfos, 1) }),
  },
  {
    dataField: 'stats',
    text: t('stats'),
    headerClasses: 'text-right',
    classes: 'text-right',
    formatter: (cell, row) => formatAffiliateStats(row),
  },
];

const AffiliateTableMini = (props) => {
  const { t } = useTranslate('affiliate', 'model');
  const { currentUser } = useCurrentUser();

  const columns = getColumns({ t, currentUser });

  return (
    <Table
      responsive
      remote
      hover
      classes="stylish-table mb-0"
      keyField="id"
      columns={columns}
      {...props}
    />
  );
};

export default AffiliateTableMini;
